import React from 'react';
import AreaTipoDivergenciaEnum from '../../../AreaTipoDivergenciaEnum';
import LabelValueComponent from '../../../components/LabelValueComponent';
import { SelectItem } from '../../../components/SelectStep';
import useBuildSubmitHandler from '../../../template/UseBuildSubmitHandler';
import TipoDivergenciasKey from '../../../TipoDivergenciasKey';
import TipoDivergenciasInfoKey from '../../../TipoDivergenciasInfoKey.';
import FinalStepTemplate, {
  useBuildDefaultInfoComponent,
} from '../../../template/FinalStepTemplate';
import {
  TipoDivergenciaComponent,
  TipoDivergenciaComponentProps,
} from '../../../TiposDeDivergencias';
import PendentesPartesDoCorteLarguraStep from './PendentesPartesDoCorteLarguraStep';


interface PendentesPartesDoCorteProps extends TipoDivergenciaComponentProps {
  payload: { tecidos: SelectItem[]; largura: string };
}

const PendentesPartesDoCorteFinalStep: TipoDivergenciaComponent<PendentesPartesDoCorteProps> = ({
  onSetStep,
  onBack,
  payload,
}) => {
  const onBackHandler = () => {
    onBack({
      component: PendentesPartesDoCorteLarguraStep as TipoDivergenciaComponent,
      payload: {
        tecidos: payload.tecidos,
      },
    });
  };

  const infoComponents = [
    ...useBuildDefaultInfoComponent(
      AreaTipoDivergenciaEnum.CORTE,
      'Pendentes partes do cortes'
    ),
    <LabelValueComponent
      label='Tecido'
      value={payload.tecidos.map((item) => item.text).join(', ')}
    />,
    <LabelValueComponent
      label='Quantidade de peças pendentes'
      value={`${payload.largura}`}
    />,
  ];

  const key = TipoDivergenciasKey.CORTE_PENDENTES_PARTES_DO_CORTE;
  const {
    loadingSave,
    loadingTipoDivergencia,
    handleSubmit,
  } = useBuildSubmitHandler(key, onSetStep);

  return (
    <FinalStepTemplate
      loading={loadingSave || loadingTipoDivergencia}
      onBack={onBackHandler}
      onSetStep={(step) => {
        handleSubmit(step, [
          ...payload.tecidos.map((item) => ({
            tipo: TipoDivergenciasInfoKey.TECIDO,
            value: item.id.toString(),
          })),
          {
            tipo: TipoDivergenciasInfoKey.LARGURA_TECIDO,
            value: payload.largura,
          },
        ]);
      }}
      progressValue={90}
      stepNumber={'4'}
      infoComponents={infoComponents}
    >
    </FinalStepTemplate>
  );
};

export default PendentesPartesDoCorteFinalStep;
